/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_2Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A gradual trial is easier to reverse than an all-at-once migration. Pick one low-dependency task, keep the original format and review it after a full work cycle. If it fits, expand the trial to another task. If it does not, you have learned which requirement failed without disrupting every workbook or asking colleagues to change tools before the evidence is available.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渐进试用更容易调整。选择一个依赖较少的任务，保留原格式，并在完整工作周期后复查。合适就继续扩展到另一项任务；不合适也能知道哪项要求未满足，而不会打乱所有工作簿，或在证据不足时要求同事一起更换工具。`)
};

/**
* | output |
* | --- |
* | "A gradual trial is easier to reverse than an all-at-once migration. Pick one low-dependency task, keep the original format and review it after a full work cy..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_6_Paragraphs_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_2(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_2(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_6_paragraphs_2 as "gc.search_guides.gridcraft_vs_excel.sections.6.paragraphs.2" }